import { Link, Outlet } from "react-router-dom";
import { type FormEvent, useState } from "react";
import { clearTraceToken, getTraceToken, setTraceToken } from "../lib/api";

export function Layout() {
  const [hasToken, setHasToken] = useState(() => !!getTraceToken());
  const [token, setToken] = useState("");

  function submit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const trimmed = token.trim();
    if (!trimmed) return;
    setTraceToken(trimmed);
    setToken("");
    setHasToken(true);
  }

  function signOut() {
    clearTraceToken();
    setHasToken(false);
  }

  return (
    <div className="min-h-screen flex flex-col">
      <header className="border-b border-slate-200 bg-white px-6 py-3 flex items-center gap-6">
        <Link to="/" className="font-mono font-semibold text-slate-900">
          swarm-rs · trace
        </Link>
        <span className="text-xs text-slate-500">
          read-only · agent execution observer
        </span>
        {hasToken && (
          <button
            type="button"
            onClick={signOut}
            className="ml-auto rounded border border-slate-300 px-2 py-1 text-xs text-slate-600 hover:bg-slate-50"
          >
            Clear token
          </button>
        )}
      </header>
      <main className="flex-1 px-6 py-6 max-w-7xl w-full mx-auto">
        {hasToken ? (
          <Outlet />
        ) : (
          <form
            onSubmit={submit}
            className="mx-auto mt-20 max-w-md rounded border border-slate-200 bg-white p-5 shadow-sm"
          >
            <h1 className="text-base font-semibold text-slate-900">
              Trace read token
            </h1>
            <p className="mt-1 text-sm text-slate-600">
              Enter the backend read token to view trace data.
            </p>
            <label className="mt-4 block text-xs font-medium text-slate-600">
              Token
              <input
                type="password"
                value={token}
                onChange={(e) => setToken(e.target.value)}
                autoFocus
                className="mt-1 w-full rounded border border-slate-300 px-3 py-2 font-mono text-sm outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
              />
            </label>
            <button
              type="submit"
              className="mt-4 rounded bg-slate-900 px-3 py-2 text-sm font-medium text-white hover:bg-slate-800"
            >
              Continue
            </button>
          </form>
        )}
      </main>
      <footer className="border-t border-slate-200 px-6 py-3 text-xs text-slate-500">
        v0.1 · live tail via polling
      </footer>
    </div>
  );
}
